import filterSeenRelatedQuestions, { reRenderRelatedQuestions } from '../storage/seenQuestionsTracker';
import {
  pushPublicationToggleChangedEvent,
  setToggleValuesInDataLayer,
} from './searchGtmEvents';
import installSearchSubmitGuard, { isSearchSubmitting } from './semantic_search/searchSubmitGuard';
import {
  applySearchStateToForm,
  buildSearchStateUrl,
  normalizeScope,
  normalizeSortMode,
  setActiveScope,
} from './semantic_search/searchScope';
import {
  fetchScopeMarkup,
  getResultsMarkup,
  renderResultsMarkup,
} from './semantic_search/searchResultsMarkup';
import buildScopeSkeletonMarkup from './semantic_search/searchScopeSkeleton';
import installScopeTooltip from './semantic_search/searchScopeTooltip';
import applySortMode from './semantic_search/searchSortMode';

$(document).ready(() => {
  // Set toggle states in datalayer as soon as search page loads.
  setToggleValuesInDataLayer();

  // Filter and mark related questions as seen.
  filterSeenRelatedQuestions();

  const pageUrl = new URL(window.location.href);
  let selectedScope = normalizeScope(pageUrl.searchParams.get('scope'));
  let selectedSortMode = normalizeSortMode(pageUrl.searchParams.get('sort'));
  const $searchForm = $('.semantic-search-form').first();

  // === Scope Info Tooltip ===
  installScopeTooltip();

  // Keep related-question navigation aligned with current scope/sort state.
  $(document).on('click', '.semantic-search-paa__link', (e) => {
    if (isSearchSubmitting()) {
      e.preventDefault();
      return;
    }
    const $link = $(e.currentTarget);
    const href = $link.attr('href');
    if (!href) {
      return;
    }
    const nextUrl = buildSearchStateUrl(href, selectedScope, selectedSortMode);
    $link.attr('href', nextUrl);
  });

  // === Initialize Scope Toggle ===
  const $toggle = $('.js-semantic-search-scope-toggle').first();
  if ($toggle.length) {
    const $content = $toggle.closest('.semantic-search-content');
    const siteName = ($toggle.data('site-name') || '').trim();
    const hasQuery = Boolean(($content.find('#id_q').val() || '').trim());
    const scopeMarkupCache = {
      [selectedScope]: getResultsMarkup($content),
    };

    let scopeFetchRequestId = 0;

    const applyScopeResults = (markup) => {
      renderResultsMarkup($content, markup);
      // Re-populate People Also Ask lists in the swapped markup without
      // advancing the seen-question tracker.
      reRenderRelatedQuestions(selectedScope, selectedSortMode);
      // Keep sort choice consistent across scope swaps (all vs current site).
      applySortMode($content.find('.js-semantic-remaining-results').first(), selectedSortMode);
      if (typeof window.fetchSearchReasoning === 'function') {
        window.fetchSearchReasoning($content[0]);
      }
      applySearchStateToForm($searchForm, selectedScope, selectedSortMode);
    };

    setActiveScope($toggle, selectedScope);
    applySearchStateToForm($searchForm, selectedScope, selectedSortMode);

    // Prefetch opposite scope results and pre-load reasoning summaries.
    if (hasQuery) {
      const oppositeScope = selectedScope === 'site' ? 'all' : 'site';
      fetchScopeMarkup(oppositeScope, scopeMarkupCache, selectedSortMode)
        .then((markup) => {
          scopeMarkupCache[oppositeScope] = markup;
          if (typeof window.fetchSearchReasoning === 'function') {
            const $temp = $('<div>').append($.parseHTML(markup, document, true));
            window.fetchSearchReasoning($temp[0]);
          }
        })
        .catch(() => null);
    }

    // Handle scope toggle clicks.
    $toggle.on('click', '[data-search-scope]', (e) => {
      const nextScope = normalizeScope($(e.currentTarget).attr('data-search-scope'));
      if (nextScope === selectedScope) {
        return;
      }
      const previousScope = selectedScope;
      selectedScope = nextScope;
      setActiveScope($toggle, nextScope);
      applySearchStateToForm($searchForm, selectedScope, selectedSortMode);
      pushPublicationToggleChangedEvent(nextScope);
      if (!hasQuery) {
        return;
      }
      scopeFetchRequestId += 1;
      const requestId = scopeFetchRequestId;

      const isShowingSkeleton = $content.find('.js-semantic-search-scope-skeleton').length > 0;
      // If skeleton is already on screen, do not save that temporary layout as real results.
      if (!isShowingSkeleton) {
        scopeMarkupCache[previousScope] = getResultsMarkup($content);
      }
      if (Object.prototype.hasOwnProperty.call(scopeMarkupCache, nextScope)) {
        applyScopeResults(scopeMarkupCache[nextScope]);
        return;
      }
      // Use the current row count so the loading state matches the live layout.
      const currentResultCount = $content.find('.semantic-remaining-result').length;
      renderResultsMarkup(
        $content,
        buildScopeSkeletonMarkup(nextScope, siteName, selectedSortMode, currentResultCount),
      );
      applySearchStateToForm($searchForm, selectedScope, selectedSortMode);
      fetchScopeMarkup(nextScope, scopeMarkupCache, selectedSortMode)
        .then((markup) => {
          if (requestId !== scopeFetchRequestId || nextScope !== selectedScope) {
            return;
          }
          scopeMarkupCache[nextScope] = markup;
          applyScopeResults(markup);
        })
        .catch(() => {
          if (requestId !== scopeFetchRequestId || nextScope !== selectedScope) {
            return;
          }
          selectedScope = previousScope;
          setActiveScope($toggle, previousScope);
          applyScopeResults(scopeMarkupCache[previousScope] || '');
        });
    });
  }

  // Keep active sort mode applied on initial render.
  applySortMode($('.js-semantic-remaining-results').first(), selectedSortMode);
  applySearchStateToForm($searchForm, selectedScope, selectedSortMode);

  // Persist selected sort mode in UI state and hidden field.
  $(document).on('click', '.js-semantic-remaining-results [data-sort-mode]', (e) => {
    const mode = normalizeSortMode($(e.currentTarget).attr('data-sort-mode'));
    const $root = $(e.currentTarget).closest('.js-semantic-remaining-results');
    selectedSortMode = mode;
    applySortMode($root, mode, true);
    applySearchStateToForm($searchForm, selectedScope, selectedSortMode);
  });

  // Ensure stateful hidden fields are up to date for normal form searches.
  $(document).on('submit', '.semantic-search-form', (e) => {
    applySearchStateToForm($(e.currentTarget), selectedScope, selectedSortMode);
  });

  installSearchSubmitGuard($('.semantic-search-form'));
});
